<template>
     <!-- ## TELA DE LOADING -->
     <div>
    <transition v-if="show" name="loadermodal">
        <div class="overlay">
            <div class="loader loadermodal"></div>
            <h3 style="position: absolute; margin-top: 14rem; color: #f7f7f7; text-align: center;">
              {{message}}
            </h3>
        </div> 
    </transition>
     
    </div>
</template>

<script>

export default {
   
    props: ['show', 'message'],
    setup() {
        
    },
}
</script>

<style scoped>
/* LOADER */
.loadermodal {
  width: auto;
  margin: 0px auto;
  padding: 20px;
  background-color: none;
  border-radius: 35px;
  box-shadow: 4px 4px 13px 0px;
  transition: all 0.2s ease-in;
}

.loader {
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #425e6c;
  width: 100px;
  height: 100px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  top: auto;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #00000094;
  z-index: 999;
  transition: opacity 0.2s ease;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>